import toast from 'react-hot-toast';
import { takeEvery, put, call } from 'redux-saga/effects';
import * as adminApi from '../../api/adminApi';
import * as actions from '../actions/adminActions';

export function* addUserRole({ payload: { user, role } }) {
  try {
    yield call(adminApi.addUserRole, { name: role.name, userId: user.id });
    yield put(actions.addUserRoleSuccess());
    yield put(actions.getUsers());
    yield put(actions.getRoles());
    toast.success('User role added.');
  } catch (e) {
    yield put(actions.addUserRoleFail());
    toast.error('An error occurred adding a user role.');
  }
}

export function* removeUserRole({ payload: { user, role } }) {
  try {
    yield call(adminApi.removeUserRole, { userId: user.id, name: role.name });
    yield put(actions.removeUserRoleSuccess());
    yield put(actions.getUsers());
    toast.success('User role removed.');
  } catch (e) {
    yield put(actions.removeUserRoleFail());
    toast.error('An error occurred removing a user role.');
  }
}

export function* userRoleSagas() {
  yield takeEvery(actions.addUserRole, addUserRole);
  yield takeEvery(actions.removeUserRole, removeUserRole);
}
